import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/index.css";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import Search from "@/pages/Search";
import EventDetail from "@/pages/EventDetail";
import Account from "@/pages/Account";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Handout from "@/pages/Handout";
import Riders from "@/pages/Riders";
import RiderProfile from "@/pages/RiderProfile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import StaticPage from "@/pages/StaticPage";
import NotFound from "@/pages/NotFound";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, wheelMultiplier: 0.9 });
    let frame;
    function raf(time) {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    }
    frame = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(frame); lenis.destroy(); };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="events" element={<Events />} />
              <Route path="search" element={<Search />} />
              <Route path="riders" element={<Riders />} />
              <Route path="riders/:slug" element={<RiderProfile />} />
              <Route path="events/:slug" element={<EventDetail />} />
              <Route path="account" element={<Account />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="admin" element={<Admin />} />
              <Route path="admin/handout/:slug" element={<Handout />} />
              <Route path="payment/success" element={<PaymentSuccess />} />
              <Route path="payment/cancel" element={<PaymentCancel />} />
              <Route path=":page" element={<StaticPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
